<template>
  <div>Logging you in...</div>
</template>
<script>
import axios from "@/config/axios";
import { mapActions } from "vuex";

export default {
  name: "AzureCallback",
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions("authModule", ["actionGetUserDetails"]),
    async exchangeCodeForToken(code, state) {
      const redirectUri = `${window.location.origin}/auth/azure/callback`;
      const backendOrigin = process.env.VUE_APP_BACKEND_ORIGIN;
      console.log("Azure callback params:", { code, state, redirectUri });
      return axios({
        baseURL: backendOrigin,
        url: "/auth/azure/callback/",
        method: "post",
        data: { code, state, redirect_uri: redirectUri }
      });
    },
    async handleSuccess(payload) {
      const {
        token,
        key,
        defaultProfile,
        role,
        user // for backend that returns user info
      } = payload || {};
      const appToken = token || key;
      if (!appToken) {
        throw new Error("Missing app token in response");
      }
      localStorage.setItem("user-token", appToken);
      if (defaultProfile?.id) {
        localStorage.setItem("profileId", defaultProfile.id);
      }
      if (role) {
        localStorage.setItem("role", role);
      }
      if (user?.role && !role) {
        localStorage.setItem("role", user.role);
      }
      await this.actionGetUserDetails().catch(err => {
        console.warn("Unable to refresh user details after Azure login", err);
      });
      const resolvedRole = role || user?.role;
      if (resolvedRole === "admin") {
        this.$router.push({ name: "ViewPADirectory" });
        return;
      }
      if (resolvedRole === "owner") {
        this.$router.push({ name: "DedicatedCustomers" });
        return;
      }
      this.$router.push({ name: "TaskDashboard" });
    },
    failAndReturn(message) {
      alert(message);
      this.$router.push({ name: "Login" });
    }
  },
  async created() {
    const params = new URLSearchParams(window.location.search);
    const error = params.get("error");
    const code = params.get("code");
    const state = params.get("state");

    if (error) {
      this.failAndReturn(`Microsoft login failed: ${error}`);
      return;
    }

    if (!code) {
      this.failAndReturn(
        "Missing authorization code. Please try signing in again."
      );
      return;
    }

    // Starting a fresh login: don't send any previous (possibly stale) token.
    localStorage.removeItem("user-token");
    this.isLoading = true;
    try {
      const response = await this.exchangeCodeForToken(code, state);
      console.log("Backend response:", response.data);
      await this.handleSuccess(response.data);
    } catch (err) {
      console.error("Azure login failed", err?.response || err);
      this.failAndReturn("Authentication failed - no token found");
    } finally {
      this.isLoading = false;
    }
  }
};
</script>
